<template>
    <div>
        <div
            v-if="$route.path.startsWith('/business')"
            class="subscribe-business"
        >
            <div class="subscribe-business__content">
                <div>
                    <h4 class="h4 mb-12">
                        Центр-инвест.
                        <span class="subscribe-business__content-title">Бизнес</span>
                        в&nbsp;Телеграме
                    </h4>
                    <p class="subscribe-business__content-text text text-light mb-24">
                        Канал для предпринимателей.<br>
                        Делимся новостями, рассказываем<br>
                        об&nbsp;актуальных продуктах и&nbsp;историях<br>
                        успеха наших клиентов.
                    </p>
                </div>
                <div>
                    <a
                        href="https://t.me/centrinvest_business"
                        target="_bkank"
                        class="subscribe-business__content-links"
                    >
                        <nuxt-img
                            src="components/popup/telegram-business.svg"
                            alt="telegram"
                            quality="80"
                            loading="lazy"
                            style="margin-right: 8px;"
                        />
                        Перейти в Telegram
                    </a>
                </div>
            </div>
            <div class="subscribe-business__content-image">
                <nuxt-img
                    src="components/popup/popup-business.png"
                    alt="business"
                    quality="80"
                    loading="lazy"
                />
            </div>
        </div>
        <div
            v-else
            class="subscribe"
        >
            <h4 class="subscribe__title h4 mb-24">&laquo;Центр-инвест&raquo; в&nbsp;ВК и&nbsp;Телеграме</h4>
            <p class="subscribe__text text text-light mb-24">
                Читайте новости банка, информацию о&nbsp;продуктах и&nbsp;спецпредложениях,
                финансовые лайфхаки и&nbsp;интервью с&nbsp;сотрудниками в&nbsp;группе&nbsp;ВК и&nbsp;Телеграм-канале.
            </p>
            <div class="subscribe-links flex flex-wrap">
                <UILink
                    v-for="linkItem in subscribeLinks"
                    :key="linkItem.type"
                    :href="linkItem.link"
                    icon-position="left"
                    link-class="subscribe-links__item ui-button"
                    :aria-label="`Ссылка на ${linkItem.type}`"
                    @click="onSubscribeHandler(linkItem.type)"
                >
                    <template #icon>
                        <component
                            :is="linkItem.icon"
                            class="subscribe-links__icon"
                        />
                    </template>
                </UILink>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import {useContext} from '@nuxtjs/composition-api';
import {UILink} from '@cibsite/ui-components-vue2';

import VkSvg from '@/assets/images/icons/social/popups/vk.svg?inline';
import TelegramSvg from '@/assets/images/icons/social/popups/telegram.svg?inline';

const subscribeLinks = [
    {
        link: 'https://vk.com/centrinvest',
        type: 'vk',
        icon: 'VkSvg',
    },
    {
        link: 'https://t.me/centrinvest_bank',
        type: 'telegram',
        icon: 'TelegramSvg',
    },
];

export default defineComponent({
    name: 'SubscribePopup',
    components: {
        VkSvg,
        TelegramSvg,
        UILink,
    },
    setup(_, context) {
        const {$ym} = useContext();

        function onSubscribeHandler(to) {
            if (to === 'vk') {
                $ym('popupVkSubscribe');
            }

            if (to === 'telegram') {
                $ym('popupTelegramSubscribe');
            }

            context.emit('hide');
        }

        return {
            subscribeLinks,
            onSubscribeHandler,
        };
    },
});
</script>

<style lang="scss" scoped>
.subscribe {
    max-width: 500px;

    &__text {
        font-size: 16px;

        @media (max-width: $mobile) {
            font-size: 12px;
        }

    }

    &-links {
        ::v-deep .ui-button {
            color: var(--color-text-0);
            background-color: transparent;
            min-width: auto;
            min-height: auto;
            padding: 0;
            transition: border $duration ease;

            @include hover {
                background-color: transparent;
            }
        }

        @media (max-width: $mobile) {
            ::v-deep .ui-button {
                min-height: 40px;
                max-height: 40px;
                height: 100%;
            }
        }

        &__icon {
            width: 32px;
        }
    }

    &-business {
        position: relative;
        width: 650px;

        @media (max-width: $mobile) {
            width: 100%;
        }

        &__content {
            max-width: 364px;
            height: 218px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            @media (max-width: $mobile) {
                max-width: 182px;
                height: 228px;
            }

            &-title {
                color: var(--color-primary-30);
            }

            &-text {
                font-size: 16px;

                @media (max-width: $mobile) {
                    font-size: 12px;
                }
            }

            &-links {
                max-width: 208px;
                width: 100%;
                display: flex;
                align-items: center;
                padding: 10px 8px;
                color: var(--color-text-70);
                background-color: #2AABEE;
                border-radius: 8px;

                @media (max-width: $mobile) {
                    font-size: 12px;
                }
            }

            &-image {
                position: absolute;
                top: -32px;
                right: -32px;
                bottom: 0;

                @media (max-width: $mobile) {
                    top: -26px;
                    right: -150px;
                }
            }
        }
    }
}
</style>
